import { Location } from '@angular/common';
import { AfterContentInit, Component, ElementRef, Input, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { BroadcastService } from 'src/app/modules/tcm-core.module';
import ResizeObserver from 'resize-observer-polyfill';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadCastEvents } from 'src/app/common/broad-cast-events.enum';

@Component({
    selector: 'tcm-main-frame',
    templateUrl: './tcm-main-frame.component.html',
    styleUrls: ['./tcm-main-frame.component.scss'],
    standalone: false
})
export class TcmMainFrameComponent implements AfterContentInit, OnDestroy {

    @Input() isLoading: boolean = false;
    @Input() hideCommands: boolean = false;
    @Input() titleKey: string;
    @Input() stretchBodyContentToViewPort: boolean;

    @ViewChild('bodyContainer', { read: ElementRef, static: true })
    bodyContainer: ElementRef<HTMLElement>;

    @ViewChild('bodyContent', { read: ElementRef, static: true })
    bodyContent: ElementRef<HTMLElement>;

    @ViewChild('headerContainer', { read: ElementRef, static: true })
    headerContainer: ElementRef<HTMLElement>;

    private resizeObserver: ResizeObserver;
    private errorSubscription: Subscription;

    constructor(private elementRef: ElementRef<HTMLElement>, private zone: NgZone,
        private broadcastService: BroadcastService,
        private location: Location) {

        this.errorSubscription = this.broadcastService
            .getEvents(BroadCastEvents.ServerErrorOccurred)
            .subscribe((e) => {
                this.isLoading = false;
                //this.location.back();
            });
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }

        this.errorSubscription.unsubscribe();
    }

    ngAfterContentInit(): void {
        const openedInModal = $(this.elementRef.nativeElement).parents('ngb-modal-window:first').length > 0;

        if (openedInModal) {
            const bodyContainerNE = this.bodyContainer.nativeElement;
            const bodyContentNE = this.bodyContent.nativeElement;
            const mainHeaderNE = this.headerContainer.nativeElement;

            this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.resizeObserver = new ResizeObserver(entries => {

                        const mainFrameMaxHeight = window.innerHeight - 100;

                        const bodyContainerMaxHeight = mainFrameMaxHeight - mainHeaderNE.offsetHeight;

                        if (this.stretchBodyContentToViewPort) {
                            bodyContainerNE.style.flex = `${bodyContainerMaxHeight}px`;
                            bodyContainerNE.classList.remove('omit-overflow');
                        }
                        else {
                            if (bodyContentNE.scrollHeight <= bodyContainerMaxHeight) {
                                bodyContainerNE.style.overflowY = 'visible';
                            }
                            else {
                                bodyContainerNE.style.overflowY = 'auto';
                            }
                        }
                    });

                    this.resizeObserver.observe(bodyContentNE);
                    this.resizeObserver.observe(document.body);
                })
            });
        }
    }
}
